import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourTravel } from '../entities/project-tour-ontour-travel.entity';

type Params = {
  sequenceId: number;
};

type Result = TourTravel[];

export const getTourTravels = createAppAsyncThunk(
  'projectTourOntour/getTourTravels',
  async (
    params: Params,
    { extra: { projectTourOntourGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const travels = await projectTourOntourGateway.getTravels(
        params.sequenceId,
      );
      return travels;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetTourTravels.Message.error'));
}
